import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./DG.css";
import { DGLetterCreationForm } from './DGLetterCreationForm';

import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";
import { ViewContainer } from "../../View";
import withMenuPermission from "../../widgets/withMenuPermission";
const utils = new ViewUtils();

const userRef = React.createRef();

class DGLetterCreation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            model: {
                BodyACharactersLeft: "2000",
                BodyBCharactersLeft: "2000",
                DGFinancialYearID: { Id: 27, Description: "01 April 2025 - 31 March 2026" }
            },
            title: "",
            id: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection)) ? this.props.location.state.selection : null
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close' },
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: this.props.onMenuSpecificPermissionItem('/DGRejectionReasonSearch').Add || this.props.onMenuSpecificPermissionItem('/DGRejectionReasonSearch').Edit ? true : false }
                    ]
                },
            ]
        };
    }

    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.close()
        } else if ("save" === buttonId) {
            this.save()
        }
    }

    handleFormValueChange = (values) => {

        if (!utils.isNull(values)) {
            this.setState({
                Name: values.Name
            });

            //if (!utils.isNull(values.DGFinancialYearID) && JSON.stringify(this.state.dependency) !== JSON.stringify(values.DGFinancialYearID)) {
            //    const DGFinancialYearID = {
            //        Name: "DGFinancialYearID",
            //        Value: values.DGFinancialYearID.Id
            //    }
            //    if (!utils.isNull(DGFinancialYearID.Value)) {
            //        this.setState({ dependency: DGFinancialYearID })
            //    }
            //};
        }
    }

    save() {
        let formValue = userRef.current.getValue();

        if (formValue !== null && typeof formValue !== 'undefined') {
            let isAdd = true;
            //if (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection)) {
            //    formValue.id = this.props.location.state.selection;
            //    isAdd = false;
            //}
            if (!utils.isNull(this.state.id)) {
                formValue.id = this.state.id;
                isAdd = false;
            }
            //let data = JSON.stringify(formValue);

            if (isAdd) {
                const url = `api/sims/dglettercreationdetails/insertdglettercreation`;
                utils.saveForm(this, userRef, url, (response) => {
                    this.setState({ message: "Letter added successfully", messageStyle: "SUCCESS", id: response.EntityId });
                }, this.error);
            } else {
                const url = `api/sims/dglettercreationdetails/updatedglettercreation`;
                utils.updateForm(this, userRef, url, (response) => {
                    this.setState({ message: "Letter updated successfully", messageStyle: "SUCCESS" });
                }, this.error);
            }
        }
    }

    error(response) {
        this.setState({ message: "A system error has accured. Please contact your system administrator", messageStyle: "ERROR" });

    }

    close() {
        this.props.history.push('/DGLetterCreationSearch');
    }

    onChangeDGFinancialYearIDHandler = (form, id, event) => {
        userRef.current.doUpdateValue('DGInterventionID', null);
        let newModel = { ...form.values }
        newModel.DGInterventionID = null;
        this.setState({ model: newModel, clearOptions: true })
    }

    clearOptionsHandler = () => {
        this.setState({ clearOptions: false });
    }

    render() {
        return (
            <ViewContainer topPadding="0">
                <p className="breadcrumbs">
                    {"DG Maintenance > Letter Creation Details"}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />


                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    enabled={true} config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <DGLetterCreationForm ref={userRef}
                                    valueChangeHandler={this.handleFormValueChange}
                                    id={this.state.id}
                                    editPermission={this.props.menuPermissionItem.Edit}
                                    data={this.state.model}
                                    model={this.state.model}
                                    onChangeDGFinancialYearIDHandler={this.onChangeDGFinancialYearIDHandler}
                                    clearOptions={this.state.clearOptions}
                                    clearOptionsHandler={this.clearOptionsHandler}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(DGLetterCreation));
